export default __webpack_public_path__ + "static/media/helpLogData.76ad7fe8.png";